import { Component, EventEmitter, forwardRef, HostListener, Input, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-keypress-events',
  templateUrl: './keypress-events.component.html',
  styleUrls: ['./keypress-events.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KeypressEventsComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => KeypressEventsComponent),
      multi: true,
    },
  ],
})
export class KeypressEventsComponent implements ControlValueAccessor {
  @Input() required = false;
  @Input() disabled = false;
  @Input() placeholder = '';
  @Output() change: EventEmitter<void> = new EventEmitter<void>();
  @Output() blur: EventEmitter<void> = new EventEmitter<void>();

  inputValue: any;
  capOn = false;

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    this.capOn = event?.getModifierState('CapsLock');
  }

  onValueChange(event: any) {
    this.inputValue = event.trim();
    this.onChange(this.inputValue);
  }

  changeIN() {
    this.change.emit();
  }

  blurIN() {
    this.blur.emit();
  }

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.inputValue = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.required && !this.inputValue) {
      return { required: true };
    }
    return null;
  }
}
